import { render } from "./MultiLingual.vue?vue&type=template&id=408fe88a&scoped=true&ts=true"
import script from "./MultiLingual.vue?vue&type=script&lang=ts"
export * from "./MultiLingual.vue?vue&type=script&lang=ts"

import "./MultiLingual.vue?vue&type=style&index=0&id=408fe88a&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408fe88a"]])

export default __exports__